module.exports = __webpack_public_path__ + "static/media/undraw_people_tax5.41f8b740.svg";